module.exports = __webpack_public_path__ + "img/talent9.07984d53.png";